define('bizzabo/models/SyncedCollection',['backbone', 'underscore', 'bizzabo/utils'], function(Backbone, _, UTILS) {

    var SyncedCollection = Backbone.Collection.extend({

        isSynced : false,
        shouldFetch : true,

        initialize : function(jsonArr) {
            if (_.isArray(jsonArr)) {
                for (var i = 0; i < jsonArr.length; i++) {
                    var newModel = new this.model(jsonArr[i]);
                    if (newModel.has('client-id')) {
                        newModel.cid = newModel.get('client-id');
                        newModel.isSynced = true;
                    }
                    this.add(newModel);
                }
            }
        },

        assimilateJson : function(arr) {
            if (_.isUndefined(arr) || arr.length === 0) {
                this.reset();
                return this;
            }
            arr = UTILS.ensureArray(arr);

            var unvisitedCids = {};
            _.each(this.models, function(model) {
                unvisitedCids[model.cid] = true;
            });

            for (var i = 0; i < arr.length; i++) {
                var jsonModel = arr[i];
                var localModel = this.get(jsonModel.id);
                if (localModel) {
                    unvisitedCids[localModel.cid] = false;
                    localModel.assimilateJson(jsonModel);
                } else {
                    localModel = this.findByEquals(jsonModel);
                    if (localModel) {
                        unvisitedCids[localModel.cid] = false;
                        localModel.assimilateJson(jsonModel);
                        this._byId[jsonModel.id] = localModel;
                        this._byId[jsonModel['client-id']] = localModel;
                    } else {
                        // add a new model
                        var newModel = new this.model(jsonModel);
                        newModel.assimilateJson(jsonModel);
                        this.add(newModel);
                    }
                }
            }

            for (var cid in unvisitedCids) {
                if (unvisitedCids[cid]) {
                    var modelToRemove = this.get(cid);
                    this.remove(modelToRemove);
                }
            }
            return this;
        },

        nonObjectAttrsEquals : function(thisModel, jsonModel) {
            for (var key in jsonModel) {
                var thisValue = thisModel.get(key);
                var otherValue = jsonModel[key];
                if (!_.isObject(thisValue)) {
                    if ((!_.isUndefined(thisValue)) && (thisValue != otherValue)) {
                        return false;
                    }
                }
            }
            return true;
        },

        findByEquals : function(jsonModel) {
            for (var i = 0; i < this.length; i++) {
                var thisModel = this.at(i);
                if (this.nonObjectAttrsEquals(thisModel, jsonModel)) {
                    return thisModel;
                }
            }
        },

        setFlagsAfterSync : function() {
            for (var i = 0; i < this.length; i++) {
                var thisModel = this.at(i);
                thisModel.setFlagsAfterSync();
            }
        },

        hasUnsavedData : function() {
            return _.any(this.models, function(model) {
                return model.hasUnsavedData();
            });
        },

        isNew : function() {
            return (!this.eventId) || this.eventId == 'new';
        }
    });

    return SyncedCollection;
});
